import { render, staticRenderFns } from "./ProgressReports.vue?vue&type=template&id=1daff5cb&"
import script from "./ProgressReports.vue?vue&type=script&lang=js&"
export * from "./ProgressReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports